export const TypeReminder = {
  event: 1,
  reminder: 2,
};
